export const suffixOptions = ['None', 'Jr.', 'Sr.', 'II', 'III', 'IV', 'V'];

export const genderOptions = ['Female', 'Male', 'Non-binary', 'I identify as another gender'];

export const pronounOptions = ['She/Her', 'He/Him', 'They/Them', 'I go by other pronouns'];

export const legalSexOptions = ['Female', 'Male', 'X or another legal sex'];

export const militaryOptions = [
  'None',
  'Currently serving',
  'Previously served',
  'One or more of my primary caregivers is serving currently',
];

export const enrollmentStatusOptions = [
  'Active Duty',
  'Veteran',
  'U.S. Reserves or National Guard',
];

export const proficiencyOptions = ['Native/Fluent', 'Advanced', 'Intermediate', 'Beginner'];

export const citizenshipOptions = [
  'U.S. citizen or U.S. national',
  'U.S. dual citizen',
  'U.S. permanent resident (green card holder)',
  'Citizen of non-U.S. country',
  'U.S. resident',
];

export const ethnicityOptions = [
  'White',
  'Black or African American',
  'American Indian or Alaska Native',
  'Latino/a/x',
  'Asian',
  'Native Hawaiian or Other Pacific Islander',
];
